exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.download-popup-enter-active,\n.download-popup-leave-active {\n  transition: opacity .2s ease;\n}\n.download-popup-enter,\n.download-popup-leave-to {\n  opacity: 0;\n}\n.send-request-slide {\n  width: 350px;\n}\n", ""]);

// exports
